import * as React from 'react';
import { useParams, useLocation } from 'react-router-dom';

import useActivePerspective from 'components/perspectives/hooks/useActivePerspective';
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from 'common/contexts';
import type { ModalTypes } from 'security-app/components/SecurityEvents/EventProcedures/EventProceduresModals';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import SecurityUI from './SecurityUI';
import GeneralUI from './GeneralUI';
import EventProceduresModals from './EventProceduresModals';

type Props = {
  navigationComponent?: React.ReactNode;
  useCoreRoutes?: boolean;
};

function Index({ navigationComponent = null, useCoreRoutes = false }: Props) {
  const { viewType } = useParams<{ viewType: string }>();
  const { pathname } = useLocation();
  const { activePerspective } = useActivePerspective();
  const isSecurityPerspective = activePerspective.id === 'security';

  const showNewUI = React.useMemo(
    () => isSecurityPerspective || !pathname.match(/\/security\//i),
    [pathname, isSecurityPerspective],
  );

  return (
    <PaginationProvider>
      <SelectedRowsProvider>
        <ModalProvider<ModalTypes, EventProceduresAPIType<EventProcedureStepAPIType[]>>>
          {navigationComponent}
          {showNewUI ? (
            <SecurityUI viewType={viewType} useCoreRoutes={useCoreRoutes} />
          ) : (
            <GeneralUI viewType={viewType} useCoreRoutes={useCoreRoutes} />
          )}
          <EventProceduresModals />
        </ModalProvider>
      </SelectedRowsProvider>
    </PaginationProvider>
  );
}

export default Index;
